export default {
  props: {
    flash: {
      type: String,
      default() {
        return this.$route.params && this.$route.params.flash
            || this.$route.query && this.$route.query.flash;
      },
    },

    flashVariant: {
      type: String,
      default() {
        return this.$route.params && this.$route.params.flashVariant
            || this.$route.query && this.$route.query.flashVariant;
      },
    }
  }
};
